import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import px2rem from './utils/px2rem'
import i18n from './i18n'
import './assets/css/public.less'
import 'swiper/css'
px2rem();
import './utils/safair'
Vue.config.productionTip = false
Vue.prototype.$eventBus = new Vue()
// 注册全局过滤器 - 千分位格式化
Vue.filter('thousandth', (num) => {
  if (!num) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});
import requestFail from './utils/errorTip'
Vue.prototype.$requestFail = requestFail
import md5 from 'js-md5'
Vue.prototype.$md5 = md5
import getQueryParam from './utils/getQueryParam'
Vue.prototype.$getQueryParam = getQueryParam


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
